import { W8ShippingAPIClient } from '../../../assets/js/modules-custom/W8_ShippingAPIClient';

const client = new W8ShippingAPIClient(
  theme.api.endpointW8,
  theme.api.nonce,
  theme.i18n.locale_pll,
);
const urlParams = new URLSearchParams(window.location.search);
let doesURLhaveParams = urlParams.has('vin') || urlParams.has('lot_number');
const successCargoUpdated = new CustomEvent('cargo-tracking-lot-updated');
const loader = document.getElementById('loader');
const loaderProcess = document.getElementById('loader-proces');
const loaderTrack = document.getElementById('loader-track');
const loaderSuccess = document.getElementById('loader-success');

document.addEventListener('DOMContentLoaded', function () {
  // Додаємо ресет лоадера коли відбувається зміна слайду
  const swiper = document.getElementById('swiper-cargo-tracking');
  setSwiperEvents(swiper.swiper);

  // При завантаженні сторінки перевіряємо чи є в URL параметри VIN or Lot Number і запускаємо прелоадер якщо є
  if (doesURLhaveParams) {
    updateLoaderProcess(25);
  }

  // Відправка форми
  const trackingForm = document.getElementById('form-tracking');
  trackingForm.addEventListener('submit', formHandler);
});

// Якщо модуль turnstile є, то запускаємо перевірку коли завантажився Turnstile один раз при завантаженні сторінки
if (theme.modules.turnstile.enabled) {
  document.addEventListener('turnstile-loaded', function () {
    checkAndLoadTrackingData();
  });
} else {
  document.addEventListener('DOMContentLoaded', function () {
    checkAndLoadTrackingData();
  });
}

/**
 * Перевірка і завантаження даних для трекінгу
 */
function checkAndLoadTrackingData() {
  // 1. Якщо URL містить VIN or Lot Number запускаємо прелоавдер (php/twig)
  // 2. Запускаємо запит на сервер
  // 2. If the request is successful, then display the result
  if (doesURLhaveParams) {
    updateLoaderProcess(75);
    const formData = urlSearchParamsToFormData(urlParams);
    formHandler(null, formData);
  }
}

/**
 * Set swiper events
 * @param {Swiper} swiper
 */
function setSwiperEvents(swiper) {
  if (swiper == undefined) {
    setTimeout(() => {
      setSwiperEvents(swiper);
    }, 1000);
  } else {
    swiper.on('slideChangeTransitionEnd', function () {
      resetLoader();
    });
  }
}

/**
 * Update loader process
 * @param {number} percentage
 */
function updateLoaderProcess(percentage = 0) {
  loaderProcess.style.transform = `translateX(${percentage - 100}%)`;
}

/**
 * Reset loader
 */
function resetLoader() {
  loaderProcess.style.transform = 'translateX(-100%)';
  loaderTrack.style.transform = 'scaleX(1)';
  loaderSuccess.style.transform = 'scale(0)';
  loader.classList.remove('loading');
}

/**
 * Convert URLSearchParams to FormData
 * @param {URLSearchParams} urlSearchParams
 * @returns {FormData}
 */
function urlSearchParamsToFormData(urlSearchParams) {
  const formData = new FormData();
  for (const [key, value] of urlSearchParams.entries()) {
    formData.append(key, value);
  }
  return formData;
}

document.addEventListener('afterTabsListChanged', function () {
  const el = document.getElementById('swiper-cargo-tracking');
  el.swiper.update();
});

/**
 * Функція обробки форми
 * @param {Event} event
 * @param {formData} formData
 */
function formHandler(event, formData = null) {
  const submitter =
    event?.submitter ?? document.getElementById('form-tracking-btn');

  if (event && formData == null) {
    doesURLhaveParams = false;
    event.preventDefault();
    formData = new FormData(event.target);
    const url = formDataToQueryString(formData);
    history.replaceState(null, '', '?' + url);
  }

  const handleSuccess = ({ html }) => {
    const errorMessage = document.getElementById('errorMessage');
    const el = document.getElementById('swiper-cargo-tracking');

    // Clear error message
    errorMessage.innerHTML = '';
    document.getElementById('lot_info').innerHTML = html;

    // Dispatch event
    document.dispatchEvent(successCargoUpdated);

    // Init tooltips
    document.tippy('[data-tippy-content]', {
      trigger: 'manual',
      allowHTML: true,
      arrow: false,
      zIndex: 10,
    });

    // Init tooltips on hover
    document.querySelectorAll('[data-tippy-content-hover]')?.forEach((el) => {
      document.tippy(el, {
        allowHTML: true,
        arrow: false,
        content: el.dataset.tippyContentHover,
        zIndex: 10,
      });
    });

    window.aboutTeamCityList();

    // Update loader process to 100%
    updateLoaderProcess(100);

    if (doesURLhaveParams) {
      // Hide loader Processbar
      setTimeout(() => {
        loaderTrack.style.transform = 'scaleX(0)';
      }, 1000);

      // Show success checkmark
      setTimeout(() => {
        loaderSuccess.style.transform = 'scale(1)';
      }, 2000);

      // Slide to the next slide
      setTimeout(() => {
        el.swiper.slideTo(1, 800);
      }, 3000);
    } else {
      el.swiper.slideTo(1, 800);
    }
  };

  const handleError = ({ message, code }) => {
    const errorMessage = document.getElementById('errorMessage');
    errorMessage.innerHTML = message;
    resetLoader();

    if (
      code === 'rest_forbidden' &&
      theme.credendionals.CLOUDFLARE_TURNSTILE_SITE_KEY_VISIBLE
    ) {
      if (errorMessage) {
        errorMessage.innerHTML = message;
        submitter.classList.add('hidden');
        const turnstileContainer = document.createElement('div');
        turnstileContainer.classList.add('turnstile', 'empty:hidden');
        errorMessage.insertAdjacentElement('afterend', turnstileContainer);

        const widgetId = turnstile.render('.turnstile', {
          sitekey: theme.credendionals.CLOUDFLARE_TURNSTILE_SITE_KEY_VISIBLE,
          theme: 'light',
          language: theme.i18n.language,
          callback: function (token) {
            client.post('cargo-tracking', {
              headers: {
                'CF-Turnstile': token,
                'CF-Turnstile-Type': 'visible',
              },
              body: Object.fromEntries(formData),
              loadingElements: [submitter],
              onSuccess: (data) => {
                turnstile.remove(widgetId);
                submitter.classList.remove('hidden');
                handleSuccess(data);
              },
              onError: (data) => {
                turnstile.remove(widgetId);
                submitter.classList.remove('hidden');
                handleError(data);
              },
            });
          },
        });
        document
          .getElementById('swiper-cargo-tracking')
          .swiper.updateAutoHeight(300);
      }
    }
    return;
  };

  client.post('cargo-tracking', {
    body: Object.fromEntries(formData),
    loadingElements: [submitter],
    onSuccess: handleSuccess,
    onError: handleError,
  });
}

/**
 * Convert FormData to query string
 * @param {formData} formData
 * @returns {string}
 */
function formDataToQueryString(formData) {
  const params = new URLSearchParams();
  for (const [key, value] of formData.entries()) {
    if (value) {
      params.append(key, value);
    }
  }
  return params.toString();
}
